<ion-col>
  <label class="col space">Prov:</label>
  <select class="taginline" [(ngModel)]="provinciaselezionato" (change)="filtra()">
    <ng-container *ngFor="let p of province">
      <option [ngValue]="p">{{p}}</option>
    </ng-container>            
  </select>    
</ion-col>


<ion-col>
  <label class="col space">Comune:  </label>
  <select class="taginline" [(ngModel)]="comuneselezionato">
    <ng-container *ngFor="let c of comunifiltrati">
      <option [ngValue]="c.citta">{{c.citta}}</option>
    </ng-container>            
  </select>  
</ion-col>


